import React, { useEffect } from "react";
import "./Founder.css";
import "@fontsource/source-sans-pro";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import MainBanner from "./components/MainBanner/MainBanner";
// import img from "./assets/images/img.webp";
import img from "./assets/images/footer_img2.jpeg";
import Banner from "./components/Banner/Banner";
import { Helmet } from "react-helmet-async";

const Founder = () => {
  useEffect(() => {
    // Scroll to top on component mount
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Founder of ISKCON – Srila Prabhupada’s Vision & Legacy</title>
        <meta
          name="description"
          content="Read about Srila Prabhupada, the spiritual visionary behind ISKCON, and how his devotion sparked a global movement in Krishna consciousness."
        />
        <meta
          name="keywords"
          content="Srila Prabhupada ISKCON, founder of ISKCON, Krishna consciousness movement, spiritual master ISKCON"
        />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="ISKCON Vijayawada" />
        <meta
          property="og:title"
          content="Founder of ISKCON – Srila Prabhupada’s Vision & Legacy"
        />
        <meta
          property="og:description"
          content="Read about Srila Prabhupada, the spiritual visionary behind ISKCON, and how his devotion sparked a global movement in Krishna consciousness."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://www.iskconvijayawada.org/founder"
        />
        <meta
          property="og:image"
          content="https://www.iskconvijayawada.org/static/media/logo.467e4780dde7b11ae4cf.png"
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Founder of ISKCON – Srila Prabhupada’s Vision & Legacy"
        />
        <meta
          name="twitter:description"
          content="Read about Srila Prabhupada, the spiritual visionary behind ISKCON, and how his devotion sparked a global movement in Krishna consciousness."
        />
        <meta
          name="twitter:image"
          content="https://www.iskconvijayawada.org/static/media/logo.467e4780dde7b11ae4cf.png"
        />

        {/* Canonical URL */}
        <link rel="canonical" href="https://www.iskconvijayawada.org/founder" />
      </Helmet>

      <Header />
      <div className="founder-page md:mt-8">
        <MainBanner />
        <div className="d-flex justify-content-center founder-img">
          <div className="text-center">
            <h5
              className="img-headline"
              style={{ paddingTop: "40px", paddingBottom: "25px" }}
            >
              His Divine Grace <br />
              A.C. BHAKTIVEDANTA SWAMI PRABHUPADA
            </h5>
            <div className="d-flex justify-content-center rounded-2xl md:h-[70vh]">
              <img
                loading="lazy"
                src={img}
                alt="Samstapaka Acharya"
                className="founder rounded-2xl"
              />
            </div>
          </div>
        </div>
        <Banner />
      </div>
      <Footer />
    </>
  );
};

export default Founder;
